export const ADMIN_DETAIL = 'ADMIN_DETAIL';
export const ADMIN_TOKEN = 'ADMIN_TOKEN';